import React from 'react';

import PreviewMail from '~/containers/Outside/PreviewMail';

export default function PreviewMailPage() {
  return (
    <PreviewMail />
  );
}
